import { Auth0ContextInterface } from '@auth0/auth0-react';
import { Dispatch } from '@reduxjs/toolkit';
import {
  setExpirationDateTime,
  setOrgId,
} from '@store/redux/features/organization';
import { extractFrom } from '@utils/redirect';

export const signIn = (
  org: string,
  dispatch: Dispatch,
  loginWithRedirect: Auth0ContextInterface['loginWithRedirect'],
  email: string,
  expirationDateTime?: number,
) => {
  dispatch(setOrgId(org));
  if (expirationDateTime) {
    dispatch(setExpirationDateTime(expirationDateTime));
  }

  const from = extractFrom();

  loginWithRedirect({
    organization: org,
    login_hint: email,
    appState: {
      returnTo: from || window.location.pathname,
    },
  });
};
